export function loadMenuImages(container) {
  if (!container) return;

  for (const image of container.querySelectorAll('img[data-konhill-menu-image][data-src]')) {
    const width = Math.ceil(image.getBoundingClientRect().width);
    image.sizes = width > 0 ? `${width}px` : image.dataset.sizes || '334px';
    image.loading = 'eager';
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-sizes');
  }
}

const observedMenus = new WeakSet();

export function observeMenuImages(container) {
  if (!observedMenus.has(container)) {
    observedMenus.add(container);
    const observer = new MutationObserver(() => {
      if (container.hasAttribute('data-active')) loadMenuImages(container);
    });
    observer.observe(container, { attributes: true, attributeFilter: ['data-active'], childList: true, subtree: true });
  }
  loadMenuImages(container);
}

const connectedDrawers = new WeakSet();

function loadOpenDrawerPanels(drawer) {
  for (const panel of drawer.querySelectorAll('details.custom-mobile-gender-menu[open]')) {
    let ancestor = panel.parentElement?.closest('details');
    let visible = true;
    while (ancestor && drawer.contains(ancestor)) {
      if (!ancestor.open) {
        visible = false;
        break;
      }
      ancestor = ancestor.parentElement?.closest('details');
    }
    if (visible) loadMenuImages(panel);
  }
}

function connectDrawer(drawer) {
  if (connectedDrawers.has(drawer)) return;
  connectedDrawers.add(drawer);
  drawer.addEventListener('toggle', () => loadOpenDrawerPanels(drawer), true);
  const observer = new MutationObserver(() => loadOpenDrawerPanels(drawer));
  observer.observe(drawer, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
  loadOpenDrawerPanels(drawer);
}

function connectDrawers(root) {
  if (root instanceof Element && root.matches('header-drawer')) connectDrawer(root);
  for (const drawer of root.querySelectorAll('header-drawer')) connectDrawer(drawer);
}

connectDrawers(document);
document.addEventListener('konhill:menu-image-load', (event) => {
  const container = event.detail?.container;
  if (container instanceof Element && container.hasAttribute('data-active')) observeMenuImages(container);
});
for (const container of document.querySelectorAll('header-menu .menu-list__submenu[data-active]')) observeMenuImages(container);
document.addEventListener('shopify:section:load', (event) => connectDrawers(event.target));
document.addEventListener('toggle', (event) => {
  if (!(event.target instanceof Element)) return;
  const drawer = event.target.closest('header-drawer');
  if (drawer) connectDrawer(drawer);
}, true);
